<template>
    <div id="contenedor-configuracion-plantillas-etiquetas-listado-desktop"
        >
      <!-- Card  -->
      <v-card class="rounded-lg mb-4 flat">
        <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
          <v-icon left small color="white">mdi-magnify</v-icon>
            Buscar
            <div  class="ml-4" style="width:20%">
              <v-text-field
              v-model="etiquetaBusca"
              dense
              filled
              rounded
              hide-details
              placeholder="..."
              class="white-placeholder"
              background-color="grey darken-2"
              >
              </v-text-field></div>
        </v-card-title>
        <v-card-text class="pt-4 flat">
          <v-list
          two-line
          dense
          flat
          nav >
            <!-- Loader -->
            <v-skeleton-loader
              v-if="$apollo.loading"
              type="table-heading, table-thead, table-tbody"
            ></v-skeleton-loader>
            <v-list-item
              v-for="(etiqueta) in etiquetas"
              :key="etiqueta.etiqueta"
              >
              <v-list-item-content class="rounded-xs mb-4 flat">
                <v-list-item-title class="base5 grey darken-3--text text-subtitle-1 py-3 pl-4"
                  >
                  <v-icon left small color="success">mdi-file-document-outline</v-icon>
                  {{ etiqueta.etiqueta }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div v-html="etiqueta.descripcion+'<br>'+etiqueta.salida"></div>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action >
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </div>
</template>

<script>
import etiquetasPropiedades from '@/components/administracion/configuracion/plantillas/etiquetas/etiquetasPropiedades';

export default {
  name: 'ConfiguracionPlantillasEtiquetasListado',

  props: {
    modulo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mostrarEtiquetas: true,
      etiquetaBusca: '',
      etiquetas: [],
    };
  },

  mounted() {
    this.etiquetas = this.etiquetasLlaves;
    this.getEtiquetas();
  },
  computed: {
    etiquetasLlaves() {
      return etiquetasPropiedades;
    },
  },
  methods: {
    activarMostrarEtiquetas() {
      this.mostrarEtiquetas = !this.mostrarEtiquetas;
    },

    getEtiquetas() {
      const buscaTexto = this.etiquetaBusca;
      this.etiquetas = this.etiquetasLlaves
        .filter((e) => (e.modulo.includes(this.modulo)
        && e.visible === true
        && e.etiqueta.toUpperCase().includes(buscaTexto.toUpperCase())))
        .sort((a, b) => {
          if (a.etiqueta < b.etiqueta) return -1;
          if (a.etiqueta > b.etiqueta) return 1;
          return 0;
        });
    },

  },
  watch: {
    etiquetaBusca: {
      handler() {
        this.getEtiquetas();
      },
    },
  },
};
</script>

<style  lang="scss"  >
.white-placeholder input {
  color: white  !important;
}

.white-placeholder input::placeholder {
  color: white !important;
  opacity: 1;
}
</style>
